import { OrderCardDTO } from "src/app/ui/models/domains/pbm/Beneficiary/dto/order-card-dto";
import { AbstractParser } from "../../parser";
import { parseProtocol } from "../pbm-parse-functions";
import { parseCard } from "./beneficiary-parse-functions";

export class OrderBeneficiaryCardParser extends AbstractParser<OrderCardDTO> {
  parse(payload: any): OrderCardDTO {
    return new OrderCardDTO(parseCard(payload.Card), parseProtocol(payload.Protocol));
  }
}
